/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    ['អធ្រាត្រ', 'ថ្ងៃត្រង់', 'ព្រឹក', 'រសៀល', 'ល្ងាច', 'យប់'],
    ,
  ],
  [
    ['អធ្រាត្រ', 'ថ្ងៃ​ត្រង់', 'ព្រឹក', 'រសៀល', 'ល្ងាច', 'យប់'],
    ,
  ],
  [
    '00:00', '12:00', ['00:00', '12:00'], ['12:00', '18:00'], ['18:00', '21:00'],
    ['21:00', '24:00']
  ]
];
